import { render, staticRenderFns } from "./LogisticsModal.vue?vue&type=template&id=4061af0c&scoped=true"
import script from "./LogisticsModal.vue?vue&type=script&lang=js"
export * from "./LogisticsModal.vue?vue&type=script&lang=js"
import style0 from "./LogisticsModal.vue?vue&type=style&index=0&id=4061af0c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4061af0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4061af0c')) {
      api.createRecord('4061af0c', component.options)
    } else {
      api.reload('4061af0c', component.options)
    }
    module.hot.accept("./LogisticsModal.vue?vue&type=template&id=4061af0c&scoped=true", function () {
      api.rerender('4061af0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OrderDetail/LogisticsModal.vue"
export default component.exports